var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C6.624 2.25 2.25 6.624 2.25 12C2.25 17.376 6.624 21.75 12 21.75C17.376 21.75 21.75 17.376 21.75 12C21.75 6.624 17.376 2.25 12 2.25ZM12 20.25C7.451 20.25 3.75 16.549 3.75 12C3.75 7.451 7.451 3.75 12 3.75C16.549 3.75 20.25 7.451 20.25 12C20.25 16.549 16.549 20.25 12 20.25Z",
    fill: "#123051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.25H12.5V8.75H14C14.414 8.75 14.75 8.414 14.75 8C14.75 7.586 14.414 7.25 14 7.25H12.5V6.5C12.5 6.224 12.276 6 12 6C11.724 6 11.5 6.224 11.5 6.5V7.25H11C9.483 7.25 8.25 8.483 8.25 10C8.25 11.517 9.483 12.75 11 12.75H11.5V15.25H10C9.586 15.25 9.25 15.586 9.25 16C9.25 16.414 9.586 16.75 10 16.75H11.5V17.5C11.5 17.776 11.724 18 12 18C12.276 18 12.5 17.776 12.5 17.5V16.75H13C14.517 16.75 15.75 15.517 15.75 14C15.75 12.483 14.517 11.25 13 11.25ZM11 11.25C10.311 11.25 9.75 10.689 9.75 10C9.75 9.311 10.311 8.75 11 8.75H11.5V11.25H11ZM13 15.25H12.5V12.75H13C13.689 12.75 14.25 13.311 14.25 14C14.25 14.689 13.689 15.25 13 15.25Z",
    fill: "#123051"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.a3897946bb8f8e99087542d95075bd30.svg";
export { ForwardRef as ReactComponent };